import styled from 'styled-components/macro';
import {spacing} from '@mui/system';
import {Grid, Typography as MuiTypography} from '@mui/material';

const StyledInputNumberRangeWrapper = styled(Grid)`
  border: 1px solid #ccc;
  border-radius: 4px;
  & fieldset {
    border: unset;
  }
`;

const Typography = styled(MuiTypography)(spacing);

export {StyledInputNumberRangeWrapper, Typography};
